/* MADHOURS — homepage interactions.
   Quick add without leaving the page, live cart count, lightweight toast. */
(function () {
  'use strict';

  var toastEl = null;
  var toastTimer = null;

  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'mh-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    toastEl.classList.add('mh-toast--on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('mh-toast--on');
    }, 2600);
  }

  function refreshCartCount() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var nodes = document.querySelectorAll('.cart-quantity-2, [data-cart-count]');
        for (var i = 0; i < nodes.length; i++) nodes[i].textContent = cart.item_count;
        return cart;
      })
      .catch(function () { /* count is cosmetic; never block the add */ });
  }

  function bindQuickAdd() {
    var forms = document.querySelectorAll('[data-mh-quick-add]');
    for (var i = 0; i < forms.length; i++) {
      forms[i].addEventListener('submit', function (e) {
        e.preventDefault();
        var form = e.currentTarget;
        var button = form.querySelector('button');
        var original = button ? button.textContent : '';

        if (button) { button.disabled = true; button.textContent = 'Adding…'; }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(form.querySelector('input[name="id"]').value),
              quantity: 1
            }]
          })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            return refreshCartCount();
          })
          .then(function (cart) {
            if (button) { button.textContent = 'Added'; }
            var count = cart && cart.item_count;
            if (count === 2) toast('2 in cart — 2 for $70 applied');
            else if (count >= 3) toast('3 in cart — 3 for $90 applied');
            else toast('Added to cart');
          })
          .catch(function () {
            if (button) button.textContent = 'Try again';
            toast('Could not add that one');
          })
          .then(function () {
            setTimeout(function () {
              if (button) { button.disabled = false; button.textContent = original; }
            }, 1600);
          });
      });
    }
  }

  function bindReveal() {
    var targets = document.querySelectorAll('[data-mh-card], .mh-props__item, .mh-review');
    if (!targets.length) return;

    function revealAll() {
      for (var i = 0; i < targets.length; i++) targets[i].classList.add('mh-reveal--in');
    }

    // No observer support: never hide anything.
    if (!('IntersectionObserver' in window)) return;

    for (var i = 0; i < targets.length; i++) targets[i].classList.add('mh-reveal');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mh-reveal--in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });

    for (var j = 0; j < targets.length; j++) io.observe(targets[j]);

    // This theme scrolls <body>, not the document, so viewport intersection
    // can never resolve. Content must never stay hidden behind an animation.
    setTimeout(revealAll, 1200);
  }

  function init() {
    bindQuickAdd();
    bindReveal();
    refreshCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
